var map = {
	"./بابايا-صورة.png": "916a",
	"./بطيخ-صورة.png": "f7de",
	"./تمر-صورة.png": "e2fd",
	"./توت-صورة.png": "6872",
	"./تين-صورة.png": "6673",
	"./حمضيات-صورة.png": "128f",
	"./خوخ-صورة.png": "cf92",
	"./رمان-صورة.png": "7305",
	"./زيتون-صورة.png": "2190",
	"./شمام-صورة.png": "d80e",
	"./عنب-صورة.png": "1f30",
	"./لوز-صورة.png": "9f9f",
	"./مانغو-صورة.png": "d09b",
	"./موز-صورة.png": "b877"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83da";